// extracted by mini-css-extract-plugin
export default {"container":"Robot_container__WXiOm","panel":"Robot_panel__TTODk","wrapper":"Robot_wrapper__tMsCL","info":"Robot_info__+juon","unit":"Robot_unit__JhNlT"};